import { useEffect } from 'react';
import type { SuperBundleServiceRoot } from 'src/apis/super-bundle-service/types';
import { useAxios } from 'src/hooks/use-axios';

export function useSuperBundleServiceRoot() {
  const superBundleService = useAxios(
    (axios, baseConfig) =>
      axios.request<SuperBundleServiceRoot>({
        ...baseConfig,
        url: PRISMA_CONFIG.superBundleService,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    superBundleService.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return superBundleService;
}

export type SuperBundleServiceRequest = ReturnType<
  typeof useSuperBundleServiceRoot
>;
